/**
 * Dropdown component constructor
 * @constructor
 * @param {string|HTMLElement} parent - The parent element or its selector where the dropdown will be appended. Defaults to document.body.
 * @param {HTMLElement} el - The dropdown element.
 * @param {string} selector - The selector for finding the dropdown elements.
 * @param {boolean} isCloseOnClickInside - Determines if the dropdown should close when clicked inside. Defaults to false.
 */

/**
 * add this link/css to html file
 * <link rel="stylesheet" type="text/css" href="/WebInterface/new-ui/modules/dropdown/dropdown.css" />
 */

import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";

export default class Dropdown {
  constructor({
    parent = document.body,
    el,
    selector = ".dropdown:not(.is-hoverable)",
    isCloseOnClickInside = false,
  }) {
    this.parent = el && el.parentNode ? el.parentNode : _$(parent);
    this.element = el;
    this.selector = selector;
    this.isCloseOnClickInside = isCloseOnClickInside;
    this.init();
  }

  init = () => {
    _$("body").on("click", (e) => {
      const targetedElement = e.target;

      const button = targetedElement.closest(".dropdown");
      if (!button) {
        return;
      }

      let parent = this.parent;
      const parentElement = _$(button).attr("parentElement");

      if (parentElement && _$(parentElement).el()) {
        parent = _$(parentElement);
        console.log(parent);
      }

      const triggerButton = _$(button).find(".dropdown-trigger", true);
      const dropDownMenu = _$(button).find(".dropdown-menu", true);

      const keyupListener = (event) => {
        const targetElement = event.target;
        let key = event.key || event.keyCode;

        let closeOnClickInside = true;

        if (
          dropDownMenu.contains(targetElement) &&
          !this.isCloseOnClickInside
        ) {
          closeOnClickInside = false;
        }

        if (
          (key === "Escape" ||
            key === "Esc" ||
            key === 27 ||
            event.type === "click") &&
          closeOnClickInside &&
          !triggerButton.contains(targetElement)
        ) {
          _$(button).removeClass("is-active");
          document.removeEventListener("keyup", keyupListener);
          document.removeEventListener("click", keyupListener);
        }
      };

      _$(button).toggleClass("is-active");
      if (_$(button).hasClass("is-active")) {
        const { left, right } = utils.getPopoverPositions(
          button,
          dropDownMenu,
          parent.el()
        );

        if (left !== 0 && right !== 0)
          dropDownMenu.classList.add("w-full-screen-dropdown");

        dropDownMenu.style.left = left;
        dropDownMenu.style.right = right;

        [("keyup", "click")].forEach((type) => {
          document.addEventListener(type, keyupListener);
        });
      } else {
        ["keyup", "click"].forEach((type) => {
          document.removeEventListener(type, keyupListener);
        });
      }
    });
  };
}
